export const DASHBOARD_PROPS = {
  PAGE: {
    TITLE: 'Dashboard',
    LIVE_BADGE: 'Live',
    DATE_LABEL_DEFAULT: 'Last 7 days',
  },
  STAT_CARDS: {
    SMART_COOLER_PRODUCTS: 'Smart Cooler Products',
    VDI_TRANSACTIONS: 'VDI Transactions',
    OPERATORS: 'Operators',
    PROVIDERS: 'Providers',
  },
  CHARTS: {
    DEFAULT_SUBTITLE: 'Success rate · in-flight · failures',
    SUBTITLES: {
      mmsMarkets: 'Market sync · throughput & failure analysis',
      mmsSales: 'Sales volume · success rate & processing errors',
      mmsProducts: 'Product delivery · completion & failure trends',
      mmsDevices: 'Device activity · response health & failures',
    },
    ALERTS_TITLE: 'Alerts',
    ALERTS_SUBTITLE: 'Resolution rate · open vs closed & failure breakdown',
  },
  RECENT_ALERTS: {
    TITLE: 'Recent Alerts',
    SUBTITLE_PREFIX: 'Latest',
    SUBTITLE_SUFFIX: 'alerts',
    EMPTY: 'No recent alerts',
    VIEW_ALL: 'View all',
    STATUS_OPEN: 'OPEN',
  },
};
